import { Component, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { InsertPatientFormComponent } from "@app/insert-patient-form/insert-patient-form.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { Modalable } from "@app/Modalable"
import {
	UpdateContactComponent,
	UpdatePayorComponent,
} from "@app/person-update-commons/person-update-commons.component"
import { UpdateGroupComponent } from "@app/update-group/update-group.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-types-create",
	imports: [
		COMMON_IMPORTS,
		ModalWrapComponent,
		GenButtonGroupComponent,
		LangValPipe,
		UpdatePayorComponent,
		UpdateGroupComponent,
		UpdateContactComponent,
		InsertPatientFormComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-modal-wrap
			(onClose)="onClose.emit()"
			modalWrapperClass="modal-800"
		>
			<h3 header>
				{{ "addd" | langVal }}
				{{ getPersonName() | langVal }}
			</h3>
			<div style="margin-bottom:20px">
				<app-gen-button-group
					[actualObj]="this"
					fieldName="personType"
					title_ph_lang="add"
					[options]="tabs"
					isTab
				/>
			</div>
			@switch (personType) {
				@case ("payor") {
					<app-update-payor
						isModalMode
						(closeModal)="onClose.emit()"
					/>
				}
				@case ("group") {
					<app-update-group
						isModalMode
						(onClose)="onClose.emit()"
					/>
				}
				@case ("contact") {
					<app-update-contact
						isModalMode
						(closeModal)="onClose.emit()"
					/>
				}
				@case ("patient") {
					<app-insert-patient-form
						hasUpdate
						(onClose)="onClose.emit()"
					/>
				}
			}
		</app-modal-wrap>
	`,
})
export class TypesCreateComponent extends Modalable {
	personType: string = "patient"
	tabs: any[] = []

	ngOnInit() {
		if (
			this.permsService.perms?.administrative ||
			this.permsService.perms?.add_new_patient
		) {
			this.tabs.push(
				{
					name: "inquirer",
					value: "patient",
				},
				{
					name: "group",
					value: "group",
				}
			)
		}
		if (this.permsService.perms?.administrative) {
			this.tabs.push(
				{
					name: "contact",
					value: "contact",
				},
				{
					name: "payor",
					value: "payor",
				}
			)
		}
	}
	getPersonName() {
		return this.tabs.find((it) => it.value === this.personType)?.name
	}
}
